import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { ContactsService } from '../../services/contacts.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, filter, forkJoin, map, merge, Observable, of, startWith, switchMap } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from 'src/app/private/services/users.service';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { PermissionService } from 'src/app/private/services/permission.service';
import {
  getLeadSourceImg as resolveLeadSourceImg,
  isLeadSourceImage,
} from 'src/app/utils/lead-source-icon.util';
import { applyCenterScopeToWhere } from 'src/app/utils/tenant-scope.util';
import { capitalizeName, formatPersonName } from 'src/app/utils/name-format.util';
import { formatPhoneImportErrors, phoneImportToastOptions, readImportErrors, resolvePhone } from 'src/app/utils/phone-country.util';
import { getLeadStatusBadgeClass } from 'src/app/utils/status-badge.util';


import * as XLSX from 'xlsx';
import moment from 'moment';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
})
export class ContactsComponent implements AfterViewInit {
  form: any = 'create';
  btnLoading = false;
  deleteParam: any = {};
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  pageSizeOptions: number[] = [10, 25, 100];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  formAction: string = 'Create';
  editData: any;
  current_id_hover = '';
  infoArray: any = [];
  isFixedColumn = true;
  displayedColumns: string[] = [];
  uploadBtnLoading = false;

  exportArrayData: any = [];
  isExportLoading = false;



  defaultFilter = [
    'fname',
    'lname',
    'email',
    'description',
    'phone',
    'mobile',
    'fax',
    'title',
    'department',
    'lead_source',
    'dob',
    'createdAt',
    'owner',
    'account_name',
    'action'
  ];

  info: any = [
    {
      key: 'first_name',
      value: 'First Name',
    },
    {
      key: 'last_name',
      value: 'Last Name',
    },
    {
      key: 'email',
      value: 'Email',
    },
    {
      key: 'description',
      value: 'Description',
    },
    {
      key: 'phone',
      value: 'Phone',
    },
    {
      key: 'mobile',
      value: 'Mobile',
    },
    {
      key: 'fax',
      value: 'Fax',
    },
    {
      key: 'title',
      value: 'Title',
    },
    {
      key: 'department',
      value: 'Department',
    },
    {
      key: 'lead_source',
      value: 'Source',
    },
    {
      key: 'lead_status',
      value: 'Status',
    },
    {
      key: 'dob',
      value: 'Date of Birth',
    },
    {
      key: 'createdAt',
      value: 'Created At',
    },
    {
      key: 'updatedAt',
      value: 'Updated At',
    },
    {
      key: 'Owner',
      value: 'Owner',
    },

  ]

  importColumnsArray: any[] = [];
  exportColumns: string[] = [];
  exportColumnArrayObject: any[] = [];
  exportDataMap: any = {};
  filterArray: any[] = [];
  displayedLebel: any = {};
  renderColumns: string[] = [];
  initialLoad = false;
  allLeadFields: any[] = [];
  isLoading = false;
  leadsRecord: any = [];
  fieldsLoaded = false;
  viewInitialized = false;
  sortPageResetBound = false;


  createContact: any = new Contact();
  loading = true;
  reloading = false;
  discription: string = '';
  users: any = [];

  /** First page from bootstrap — consumed once by loadData() to avoid duplicate getAllContacts. */
  private initialContactsBootstrapResponse: any = null;
  private consumeInitialContactsBootstrap = false;
  private sortContactsPageResetBound = false;

  isAdmin: boolean = false;
  canCreateContactGroup = false;
  selectedContacts: any[] = [];

  constructor(
    private api: ContactsService,
    private localStorage: LocalStorageService,
    private modalService: NgbModal,
    private toast: ToastrService,
    private userApi: UsersService,
    private tracker: TrackingService,
    private permissionService: PermissionService,
    private router: Router,
  ) {
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  ngOnInit() {
    this.canCreateContactGroup = this.permissionService.hasModuleAccess('campaign');
    this.getAllUsers();
  }

  openContactProfile(element: any): void {
    const contactId = element?.contact_id;
    if (contactId == null || contactId === '') {
      return;
    }
    const hashPath = this.router.serializeUrl(
      this.router.createUrlTree(['/main/contacts', contactId])
    );
    const url = `${window.location.origin}${window.location.pathname}#${hashPath}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  private fetchContactsListPage$(): Observable<any> {
    let param: any = {
      where: applyCenterScopeToWhere(
        { client_id: parseInt(this.localStorage.getClientId(), 10) },
        this.localStorage
      ),
      filter: {},
      page: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      order: {
        col: '"contact"."updatedAt"',
        dir: 'DESC',
      },
    };

    if (this.searchQuery.value) {
      const key = Object.keys(this.searchQuery.value)[0];
      const value = this.searchQuery.value[key];
      const staticFilterFieds = [
        'first_name',
        'last_name',
        'email',
        'phone',
        'mobile',
        'fax',
        'title',
        'department',
        'source',
        'dob',
        'description',
      ];
      if (staticFilterFieds.includes(key)) {
        param.filter = { staticFilter: { [key]: value } };
      } else {
        param.filter = { dynamicFilter: { [key]: value } };
      }
    }

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    return this.api.getAllContacts(param).pipe(catchError(() => of(null)));
  }

  private applyContactsRowsToTable(data: any): void {
    const rows = Array.isArray(data?.rows) ? data.rows : [];
    this.totalRows = data?.count ?? 0;
    const selectedIds = new Set(
      this.selectedContacts.map((item) => item.contact_id)
    );
    const mappedRows = rows.map((item: any) => ({
      ...item,
      isSelected: selectedIds.has(item.contact_id),
      lead_status:
        item.lead_status ||
        item.fields?.lead_status ||
        item.fields?.contact_stage ||
        '',
    }));
    this.dataSource = new MatTableDataSource<any>(mappedRows);
    this.initialLoad = false;
    this.loading = false;
    this.reloading = false;
  }

  private bootstrapContactsModule(): void {
    this.loading = true;
    const client_id = this.localStorage.getClientId();
    const fields$ = this.api.getContactFields({ client_id }).pipe(
      catchError((err) => {
        console.error('getContactFields failed', err);
        return of({ fields: [] as any[] });
      })
    );
    const rows$ = this.fetchContactsListPage$().pipe(
      map((response: any) => {
        if (response === null) {
          return { rows: [], count: 0 };
        }
        return {
          rows: response?.rows ?? [],
          count: response?.count ?? 0,
        };
      }),
      catchError(() => of({ rows: [], count: 0 }))
    );

    forkJoin({ fields: fields$, rows: rows$ })
      .pipe(
        catchError((err) => {
          console.error('contacts bootstrap failed', err);
          return of({
            fields: { fields: [] as any[] },
            rows: { rows: [], count: 0 },
          });
        })
      )
      .subscribe({
        next: ({ fields, rows }) => {
          this.applyContactFieldsLayout(fields);
          this.initialContactsBootstrapResponse = rows;
          this.consumeInitialContactsBootstrap = true;
          this.applyContactsRowsToTable(rows);
          this.loadData();
        },
        error: (e) => {
          this.initialLoad = false;
          this.loading = false;
          this.toast.error('Something went wrong, please refresh the page');
          console.error(e);
        },
      });
  }

  private applyContactFieldsLayout(data: any): void {
    this.displayedColumns = [];
    this.filterArray = [];
    this.importColumnsArray = [];
    this.exportColumnArrayObject = [];
    this.exportColumns = [];
    this.exportDataMap = {};
    this.displayedLebel = {};
    this.infoArray = this.info.map((item: any) => ({ key: item.key, value: item.value }));
    this.displayedColumns = [];

    if (this.isFixedColumn) {
      this.displayedColumns.push('fname');
      this.displayedColumns.push('info');
      this.displayedColumns.push('email');
      this.displayedColumns.push('phone');
      this.displayedColumns.push('mobile');
      this.displayedColumns.push('department');
      this.displayedColumns.push('source');
      this.displayedColumns.push('lead_status');
      this.displayedColumns.push('owner');
      this.displayedColumns.push('account_name');

      this.displayedLebel['fname'] = 'Contact Name';
      this.displayedLebel['info'] = 'Info';
      this.displayedLebel['email'] = 'Email';
      this.displayedLebel['phone'] = 'Phone';
      this.displayedLebel['mobile'] = 'Mobile';
      this.displayedLebel['department'] = 'Department';
      this.displayedLebel['source'] = 'Source';
      this.displayedLebel['lead_status'] = 'Status';
      this.displayedLebel['owner'] = 'Owner';
      this.displayedLebel['account_name'] = 'Account Name';
      this.displayedLebel['action'] = 'Action';

    }
    this.allLeadFields = data?.fields.sort((a: any, b: any) => a.sequence - b.sequence);
    this.fieldsLoaded = true;

    if (this.isFixedColumn) {
      // Additional fields from the form
      this.importColumnsArray.push({ key: 'first_name', value: 'First Name' });
      this.importColumnsArray.push({ key: 'last_name', value: 'Last Name' });
      this.importColumnsArray.push({ key: 'email', value: 'Contact Email' }); // Already added
      // this.importColumnsArray.push({ key: 'contact_owner', value: 'Contact Owner' });
      this.importColumnsArray.push({ key: 'fax', value: 'Fax' });
      this.importColumnsArray.push({ key: 'title', value: 'Title' });
      this.importColumnsArray.push({ key: 'phone', value: 'Contact Phone' }); // Already added
      this.importColumnsArray.push({ key: 'department', value: 'Department' });
      this.importColumnsArray.push({ key: 'secondary_email', value: 'Secondary Email' });
      this.importColumnsArray.push({ key: 'mobile', value: 'Mobile' });
      this.importColumnsArray.push({ key: 'country_code', value: 'Country Code' });
      this.importColumnsArray.push({ key: 'address.street', value: 'Street' });
      this.importColumnsArray.push({ key: 'address.city', value: 'City' });
      this.importColumnsArray.push({ key: 'address.state', value: 'State' });
      this.importColumnsArray.push({ key: 'address.postal_code', value: 'Postal Code' });
      this.importColumnsArray.push({ key: 'address.country', value: 'Country' });
      this.importColumnsArray.push({ key: 'description', value: 'Description' });
      this.importColumnsArray.push({ key: 'skype_id', value: 'Skype ID' });
      this.importColumnsArray.push({ key: 'lead_source', value: 'Contact Source' });
      this.importColumnsArray.push({ key: 'dob', value: 'Date of Birth' });


      this.exportColumnArrayObject.push({ key: 'contact_name', value: 'Contact Name' })
      this.exportColumnArrayObject.push({ key: 'contact_email', value: 'Contact Email' })
      this.exportColumnArrayObject.push({ key: 'contact_phone', value: 'Contact Phone' })
      this.exportColumnArrayObject.push({ key: 'company_name', value: 'Organization' })
      this.exportColumnArrayObject.push({ key: 'lead_source', value: 'Lead Source' })



      this.filterArray.push({ key: 'first_name', value: 'First Name' });
      this.filterArray.push({ key: 'last_name', value: 'Last Name' });
      this.filterArray.push({ key: 'email', value: 'Email' });
      this.filterArray.push({ key: 'description', value: 'Description' });
      this.filterArray.push({ key: 'phone', value: 'Phone' });
      this.filterArray.push({ key: 'mobile', value: 'Mobile' });
      this.filterArray.push({ key: 'fax', value: 'Fax' });
      this.filterArray.push({ key: 'title', value: 'Title' });
      this.filterArray.push({ key: 'department', value: 'Department' });
      this.filterArray.push({ key: 'source', value: 'Source' });

      this.exportColumns.push('First Name');
      this.exportColumns.push('Last Name');
      this.exportColumns.push('Contact Owner');
      this.exportColumns.push('Fax');
      this.exportColumns.push('Title');
      this.exportColumns.push('Contact Phone');
      this.exportColumns.push('Department');
      this.exportColumns.push('Secondary Email');
      this.exportColumns.push('Mobile');
      this.exportColumns.push('Street');
      this.exportColumns.push('City');
      this.exportColumns.push('State');
      this.exportColumns.push('Postal Code');
      this.exportColumns.push('Country');
      this.exportColumns.push('Description');
      this.exportColumns.push('Skype ID');
      this.exportColumns.push('Contact Source');
      this.exportColumns.push('Date of Birth');


      this.exportDataMap['First Name'] = 'first_name';
      this.exportDataMap['Last Name'] = 'last_name';
      this.exportDataMap['Contact Owner'] = 'contact_owner';
      this.exportDataMap['Fax'] = 'fax';
      this.exportDataMap['Title'] = 'title';
      this.exportDataMap['Contact Phone'] = 'phone';
      this.exportDataMap['Department'] = 'department';
      this.exportDataMap['Secondary Email'] = 'secondary_email';
      this.exportDataMap['Mobile'] = 'mobile';
      this.exportDataMap['Street'] = 'address.street';
      this.exportDataMap['City'] = 'address.city';
      this.exportDataMap['State'] = 'address.state';
      this.exportDataMap['Postal Code'] = 'address.postal_code';
      this.exportDataMap['Country'] = 'address.country';
      this.exportDataMap['Description'] = 'description';
      this.exportDataMap['Skype ID'] = 'skype_id';
      this.exportDataMap['Contact Source'] = 'lead_source';
      this.exportDataMap['Date of Birth'] = 'dob';

    }


    data?.fields?.forEach((element: any) => {

      this.infoArray.push({ key: element.field_name, value: element.label });

      if (element.isVisibleTable == 'true' && !this.displayedColumns.includes(element.field_name)) {
        this.displayedColumns.push(element.field_name);
      }

      this.displayedLebel[element.field_name] = element.label;
      console.log('element.field_name', element)
      if (element.type == 'text') {
        this.filterArray.push({
          key: element.field_name,
          value: element.label
        });
      }



      this.importColumnsArray.push({ key: element.field_name, value: element.label });

      this.exportColumnArrayObject.push({ key: element.field_name, value: element.label })
    });

    // this.exportColumns = [];



    data?.fields?.forEach((element: any) => {
      this.exportColumns.push(element.label);
      this.exportDataMap[element.label] = element.field_name;
    });


    // fixed colums irrespective of fixed column


    this.exportColumns.push('Created Time');
    this.exportColumns.push('Updated Time');


    this.exportColumnArrayObject.push({ key: 'lead_date', value: 'Lead Date' })
    this.exportColumnArrayObject.push({ key: 'lead_time', value: 'Lead Time' })
    this.exportColumnArrayObject.push({ key: 'lead_type', value: 'Lead Type' })
    this.exportColumnArrayObject.push({ key: 'lead_status', value: 'Lead Status' })
    this.exportColumnArrayObject.push({ key: 'assign_to', value: 'Assign To' })



    this.exportDataMap['Created Time'] = 'createdAt';
    this.exportDataMap['Updated Time'] = 'updatedAt';

    this.displayedColumns.push('action');
    this.renderColumns = ['select', ...this.displayedColumns];
    this.displayedColumns = this.renderColumns;
    this.displayedLebel['select'] = '';
    this.loading = false;
    // action column
  }

  getAllContactFields() {
    this.loading = true;
    this.api.getContactFields({ client_id: this.localStorage.getClientId() }).subscribe({
      next: (data) => this.applyContactFieldsLayout(data),
      error: (e) => {
        this.initialLoad = false;
        this.loading = false;
        this.toast.error('Something went wrong, please refresh the page');
        console.error(e);
      },
    });
  }


  importData(event: any) {
    if (event.length > 0) {
      this.uploadBtnLoading = true;
      const normalized = event.map((row: any) => ({
        ...row,
        first_name: row.first_name
          ? capitalizeName(String(row.first_name))
          : row.first_name,
        last_name: row.last_name
          ? capitalizeName(String(row.last_name))
          : row.last_name,
      }));
      const phoneErrors: { row: number; message: string }[] = [];
      normalized.forEach((row: any, index: number) => {
        ['mobile', 'phone'].forEach((key) => {
          if (!String(row[key] || '').trim()) return;
          const resolved = resolvePhone(row.country_code, row[key]);
          if (!resolved.ok) {
            phoneErrors.push({ row: index + 2, message: `${key}: ${resolved.error}` });
            return;
          }
          if (resolved.hasPhone) {
            row[key] = resolved.nationalNumber;
            row.country_code = resolved.countryCode;
          }
        });
      });
      if (phoneErrors.length) {
        this.uploadBtnLoading = false;
        this.toast.error(formatPhoneImportErrors(phoneErrors), 'Import validation', phoneImportToastOptions);
        return;
      }
      this.api.createBulkContact(normalized).subscribe({
        next: (res) => {
          if (res) {
            this.uploadBtnLoading = false
            this.toast.success("Data uploaded Successfully");
            const desc = `Contacts imported with total: ${event.length}`;
            this.tracker.track("Import", "Contact", desc); // ✅ Tracking
            this.modalService.dismissAll()
            this.reloadData();
          }
        },
        error: (e) => {
          this.uploadBtnLoading = false
          const apiErrors = readImportErrors(e);
          this.toast.error(
            apiErrors.length ? formatPhoneImportErrors(apiErrors) : 'Contact import failed',
            'Import validation',
            phoneImportToastOptions
          );
        }
      })
    }
    else {

      this.toast.error("Please Upload Data")
    }
    console.log(event)
  }



  export(header: any) {


    this.exportArrayData = [];
    let param: any = {
      where: applyCenterScopeToWhere(
        { client_id: this.localStorage.getClientId() },
        this.localStorage
      ),
    };

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    this.isExportLoading = true;

    this.api.getAllContact(param).subscribe({
      next: (data) => {
        this.isExportLoading = false;
        this.leadsRecord = data || [];
        this.isLoading = false;
        this.tracker.track("Export", "Contact", `Contacts exported on ${moment().format('YYYY-MM-DD HH:mm:ss')}`); // ✅ Tracking



        if (data.length > 0) {
          data.forEach((elem: any) => {
            const obj = {
              ...elem.fields,
              ...elem,
              assign_to:
                elem.user == null
                  ? ''
                  : elem.user.prefix +
                  ' ' +
                  elem.user.fname +
                  ' ' +
                  elem.user.lname,
            };
            this.exportArrayData.push(obj);
          });
        }

        let exportColumns = header.map((item: any) => {
          return item.value
        });

        const columnMapping = this.exportColumnArrayObject.reduce((map: any, col: any) => {
          map[col.value] = col.key;
          return map;
        }, {});


        console.log("exportColumns", exportColumns);
        console.log("exportDataMap", this.exportDataMap);
        exportColumns.map((col: any) => {
          console.log(this.exportDataMap[col], col);
        });

        // Step 2: Filter and map exportColumns to their corresponding display names
        const selectedColumns = exportColumns.map((key: any) => ({
          key: this.exportDataMap[key] || key, // Use the exportDataMap to get the key
          displayName: key // Fallback to the key if no mapping is found
        }));

        console.log("selectedColumns", selectedColumns);
        // Step 3: Generate Excel headers based on selected columns
        // const excelHeader = selectedColumns.map((col:any) => col.displayName);
        const excelHeader = [...new Set(selectedColumns.map((col: any) => col.displayName))];

        // Step 4: Prepare Excel data dynamically
        const excelData = this.exportArrayData.map((lead: any) => {
          const row: any = {};
          selectedColumns.forEach((col: any) => {
            row[col.displayName] = lead[col.key] || ''; // Use mapped display name as key

            if (col.key === 'address.street' || col.key === 'address.city' || col.key === 'address.state' || col.key === 'address.postal_code' || col.key === 'address.country') {
              if (col.key === 'address.street') {
                row[col.displayName] = lead.address?.street || '';
              }

              if (col.key === 'address.city') {
                row[col.displayName] = lead.address?.city || '';
              }

              if (col.key === 'address.state') {
                row[col.displayName] = lead.address?.state || '';
              }

              if (col.key === 'address.postal_code') {
                row[col.displayName] = lead.address?.postal_code || '';
              }

              if (col.key === 'address.country') {
                row[col.displayName] = lead.address?.country || '';
              }


            }
          });
          return row;
        });


        // Step 5: Create workbook and worksheet
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

        // Add headers and data to worksheet
        XLSX.utils.sheet_add_aoa(ws, [excelHeader]); // Add header row
        XLSX.utils.sheet_add_json(ws, excelData, {
          origin: 'A2', // Start from the second row
          skipHeader: true,
        });

        // Append worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        // Step 6: Generate file name with timestamp
        const date = new Date();
        const fileName = `Contacts_data_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${date.getTime()}.xlsx`;

        // Step 7: Write the workbook to a file
        XLSX.writeFile(wb, fileName);

      },
      error: (e) => {
        this.isExportLoading = false;
        this.isLoading = false;
      },
    });
  }

  ngAfterViewInit() {
    this.viewInitialized = true;
    this.bootstrapContactsModule();
  }

  getCellValue(element: any, it: string): any {
    switch (it) {
      case "fname":
        return formatPersonName(element.first_name, element.last_name);
      case "email":
        return element.email || 'N/A';
      case "description":
        return element.description || 'N/A';
      case "phone":
        return element.phone || 'N/A';
      case "mobile":
        return element.mobile || 'N/A';
      case "fax":
        return element.fax || 'N/A';
      case "title":
        return element.title || 'N/A';
      case "department":
        return element.department || 'N/A';
      case "source":
      case "lead_source":
        return this.getContactSource(element) || 'N/A';
      case "lead_status":
      case "contact_stage":
        return this.getContactStatus(element) || 'N/A';
      case "dob":
        return element.dob || 'N/A';
      case "createdAt":
        return element.createdAt;
      case "owner":
        return element.user ? element.user?.fname + ' ' + element.user?.lname : 'N/A';
      case "account_name":
        return element.account ? element.account?.account_name : 'N/A';
      default:
        return this.checkNull(element, it);
    }



  }


  getContactSource(element: any): string {
    return String(
      element?.lead_source ||
        element?.source ||
        element?.fields?.lead_source ||
        element?.fields?.source ||
        ''
    ).trim();
  }

  getContactStatus(element: any): string {
    return String(
      element?.lead_status ||
        element?.fields?.lead_status ||
        element?.fields?.contact_stage ||
        ''
    ).trim();
  }

  getLeadStatusClass(status?: string | null): string {
    return getLeadStatusBadgeClass(status);
  }

  getLeadStatusLabel(status?: string | null): string {
    const value = String(status ?? '').trim();
    return value || 'N/A';
  }

  isSourceImage(source: string) {
    return isLeadSourceImage(source);
  }

  getLeadSourceImg(source: string) {
    return resolveLeadSourceImg(source);
  }

  checkNull(data: any, col: any) {

    let row = ""
    try {
      if (data['fields'][col] != null) {
        row = data['fields'][col] || 'N/A';
        // console.log("--->",data['fields'][col])
      } else {
        row = 'N/A';
      }
    }
    catch (err) {

    }


    return row || 'N/A';
  }

  getAllUsers() {
    let param = {
      client_id: this.localStorage.getClientId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  searchFilter(query: any) {
    console.log('Search Query:', query);
    this.searchQuery.setValue(query);
  }



  loadData() {
    try {
      if (this.sort && !this.sortPageResetBound) {
        this.sortPageResetBound = true;
        this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      }
      const sortChange$: Observable<any> = this.sort ? this.sort.sortChange : of(null);
      const page$: Observable<any> = this.paginator ? this.paginator.page : of(null);
      merge(
        this.searchQuery.valueChanges,
        sortChange$,
        page$
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            if (
              this.consumeInitialContactsBootstrap &&
              this.initialContactsBootstrapResponse != null
            ) {
              this.consumeInitialContactsBootstrap = false;
              const cached = this.initialContactsBootstrapResponse;
              this.initialContactsBootstrapResponse = null;
              return of(cached);
            }
            this.reloading = true;
            return this.fetchContactsListPage$();
          }),
          map((response: any) => {
            if (response === null) {
              this.totalRows = 0;
              return [];
            }
            this.totalRows = response.count ?? 0;
            return response?.rows ?? [];
          })
        )
        .subscribe({
          next: (data) => {
            this.loading = false;
            this.reloading = false;
            const selectedIds = new Set(
              this.selectedContacts.map((item) => item.contact_id)
            );
            const rows = (data || []).map((item: any) => ({
              ...item,
              isSelected: selectedIds.has(item.contact_id),
            }));
            this.dataSource = new MatTableDataSource<any>(rows);
            this.initialLoad = false;
          },
          error: (e) => {
            console.error(e);
            this.loading = false;
            this.reloading = false;
            this.initialLoad = false;
          },
          complete: () => {
            this.loading = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      console.error(e);
      this.loading = false;
      this.reloading = false;
    }
  }

  reloadData() {
    try {

      merge(
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;
            let param: any = {
              where: applyCenterScopeToWhere(
                { client_id: parseInt(this.localStorage.getClientId(), 10) },
                this.localStorage
              ),
              filter: {},
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              "order": {
                "col": "\"contact\".\"updatedAt\"",
                "dir": "DESC"
              },
            };

            if (this.searchQuery.value) {
              param.filter = this.searchQuery.value;
            }

            if (!this.isAdmin) {
              param.where.user_id = this.localStorage.getUserId();
            }

            return this.api
              .getAllContacts(param)
              .pipe(catchError(() => of(null)));
          }),
          map((response: any) => {
            if (response === null) {
              this.reloading = false;
              return [];
            }
            this.totalRows = response.count;
            return response?.rows || [];
          })
        )
        .subscribe({
          next: (data) => {
            console.log('data', data);
            const selectedIds = new Set(
              this.selectedContacts.map((item) => item.contact_id)
            );
            const rows = (data || []).map((item: any) => ({
              ...item,
              isSelected: selectedIds.has(item.contact_id),
            }));
            this.dataSource = new MatTableDataSource<any>(rows);
          },
          error: (e) => {
            console.error(e);
            this.reloading = false;
          },
          complete: () => {
            this.reloading = false;
          },
        });
    } catch (e) {
      console.error(e);
      this.reloading = false;
    }
  }


  editForm(element: any, content: any) {
    this.formAction = 'Update';

    this.editData = element;
    this.modalService.open(content, {
      size: 'lg',
      scrollable: true,
      centered: true,
    });
  }


  open(content: any) {
    this.form = 'create';
    this.formAction = 'Create';
    this.createContact = new Contact();
    this.modalService.open(content, {
      size: 'lg',
      scrollable: true,
      centered: true,
    });
  }

  create() {
    this.btnLoading = true;
    this.createContact.client_id = this.localStorage.getClientId();
    this.createContact.user_id = this.localStorage.getUserId();
    this.createContact.center_id = this.localStorage.getCenterId();
    this.api.createContact(this.createContact).subscribe({
      next: (res: any) => {
        this.btnLoading = false;
        this.modalService.dismissAll();
        this.toast.success('Contact created successfully');
        const desc = `Contact created with name: ${this.createContact.first_name} ${this.createContact.last_name} with contact id: ${res.contact_id}`;
        this.tracker.track("Create", "Contact", desc); // ✅ Tracking
        this.loadData();
      },
      error: (err: any) => {
        this.btnLoading = false;
        this.toast.error('Error creating contact');
      },
    });
  }

  update() {
    this.btnLoading = true;
    this.api.updateContact(this.createContact).subscribe({
      next: (res: any) => {
        this.btnLoading = false;
        this.modalService.dismissAll();
        this.toast.success('Contact updated successfully');
        const desc = `Contact updated with name: ${this.createContact.first_name} ${this.createContact.last_name} and contact id: ${this.createContact.id}`;
        this.tracker.track("Update", "Contact", desc); // ✅ Tracking
        this.loadData();
      },
      error: (err: any) => {
        this.btnLoading = false;
        this.toast.error('Error updating contact');
      },
    });
  }

  deleteModal(content: any, id: any) {
    let param = {
      contact_id: id,
      client_id: this.localStorage.getClientId(),
    };
    this.deleteParam = param;
    this.modalService.open(content, {
      size: 'l',
      scrollable: true,
      centered: true,
    });
  }

  handleDeleteEvent() {
    this.btnLoading = true;
    const payload = {
      contact_id: this.deleteParam.contact_id,
    };
    this.api.deleteContact(payload).subscribe({
      next: (res: any) => {
        this.reloading = false;
        this.modalService.dismissAll();
        this.reloadData();
        this.btnLoading = false;
        this.toast.success('Contact deleted successfully');
        const desc = `Contact deleted with contact id: ${this.deleteParam?.contact_id}`;

        this.tracker.track("Delete", "Contact", desc); // ✅ Tracking
      },
      error: (err: any) => {
        console.error(err);
        this.reloading = false;
        this.btnLoading = false;
        this.toast.error('Error deleting contact');
      },
    });
  }


  openDescriptionModal(content: any, description: string): void {
    this.discription = description;
    this.modalService.open(content, {
      size: 'md',
      scrollable: true,
      centered: true,
    });
  }

  updateHoverState(id: string): void {
    this.current_id_hover = id;
  }

  isAllSelected(): boolean {
    if (!this.dataSource?.data?.length) {
      return false;
    }
    return this.dataSource.data.every((item) => item.isSelected);
  }

  isAnySelected(): boolean {
    return this.dataSource.data.some((item) => item.isSelected);
  }

  toggleContactSelection(event: any, element: any): void {
    element.isSelected = event.checked;

    if (event.checked) {
      const exists = this.selectedContacts.some(
        (item) => item.contact_id === element.contact_id
      );
      if (!exists) {
        this.selectedContacts.push(element);
      }
      return;
    }

    this.selectedContacts = this.selectedContacts.filter(
      (item) => item.contact_id !== element.contact_id
    );
  }

  selectAll(event: any): void {
    if (!event.checked) {
      this.selectedContacts = [];
    }

    this.dataSource.data = this.dataSource.data.map((item) => ({
      ...item,
      isSelected: event.checked,
    }));

    if (event.checked) {
      const pageIds = new Set(
        this.dataSource.data.map((item) => item.contact_id)
      );
      const kept = this.selectedContacts.filter(
        (item) => !pageIds.has(item.contact_id)
      );
      this.selectedContacts = [...kept, ...this.dataSource.data];
    } else {
      const pageIds = new Set(
        this.dataSource.data.map((item) => item.contact_id)
      );
      this.selectedContacts = this.selectedContacts.filter(
        (item) => !pageIds.has(item.contact_id)
      );
    }
  }

  openBulkCreateContactGroup(content: any): void {
    if (this.selectedContacts.length < 1) {
      this.toast.error('Please select at least one contact.');
      return;
    }

    this.modalService.open(content, {
      size: 'lg',
      scrollable: true,
      centered: true,
    });
  }

  onContactGroupCreatedFromContacts(): void {
    this.selectedContacts = [];
    this.dataSource.data = this.dataSource.data.map((item) => ({
      ...item,
      isSelected: false,
    }));
    this.reloadData();
  }

  scrollTableTo(direction: any) {
    const el: any = document.querySelector('.table-container');
    console.log('el', el);
    console.log('direction', direction);
    if (direction === 'right') {
      el?.scrollBy({
        left: el.offsetWidth,
        behavior: 'smooth',
      });
    } else if (direction === 'left') {
      el?.scrollBy({
        left: -el.offsetWidth,
        behavior: 'smooth',
      });
    }
  }

}


export class Contact {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  description: string;
  phone: string;
  address: string;
  source: string;
  status: string;
  user_id: number;
  client_id: number;
  center_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string;
  constructor() {
    this.id = 0;
    this.first_name = '';
    this.last_name = '';
    this.email = '';
    this.description = '';
    this.phone = '';
    this.address = '';
    this.source = '';
    this.status = '';
    this.user_id = 0;
    this.client_id = 0;
    this.center_id = 0;
    this.created_at = '';
    this.updated_at = '';
    this.deleted_at = '';
  }
}